import React, { useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AnimatedPage from '../components/animatedPage'
import Banner from '../components/banner/banner'
import ScrollContainer from 'react-indiana-drag-scroll'

const TabsPage = ({ title, bg, tabs }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  )
  const defaultActiveTab = parseInt(queryParams.get('tab')) || 0
  const [activeTab, setActiveTab] = useState(defaultActiveTab)
    const handleTabClick = index => {
    setActiveTab(index)
    queryParams.set('tab', index)
    navigate({ search: queryParams.toString() })
  }
  return (
    <AnimatedPage>
      <Banner text={title} bg={bg} />
      <div className='w-full max-w-8xl my-4 flex items-center justify-center gap-8'>
        <ScrollContainer
          horizontal
          className='flex gap-3 lg:gap-5   scroll-smooth snap-mandatory snap-x overflow-x-auto  px-2 scroll-px-3 '
          role='tablist'
        >
          {tabs?.map((tab, index) => (
            <button
              key={index}
              className={`whitespace-nowrap shrink-0 snap-center ${
                activeTab === index ? 'text-[#000000]' : 'text-[#747474]'
              } text-lg font-semibold border-b-4 px-4 pb-1 transition-all ${
                activeTab === index ? 'border-[#FF4D4D]' : 'border-transparent'
              }`}
              onClick={() => handleTabClick(index)}
            >
              {tab.header}
            </button>
          ))}
        </ScrollContainer>
      </div>
      <div className='w-full flex items-center justify-center my-8'>
        <div className='w-full flex items-center justify-center'>
          {tabs[activeTab]?.content}
        </div>
      </div>
    </AnimatedPage>
  )
}

export default TabsPage
